function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
  fill: "#0A648F",
  stroke: "#0A648F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8047 7.20277C18.0651 7.47314 18.0651 7.91148 17.8047 8.18184L10.4714 15.7972C10.2111 16.0676 9.78894 16.0676 9.5286 15.7972L6.19526 12.3357C5.93491 12.0653 5.93491 11.627 6.19526 11.3566C6.45561 11.0863 6.87772 11.0863 7.13807 11.3566L10 14.3286L16.8619 7.20277C17.1223 6.93241 17.5444 6.93241 17.8047 7.20277Z",
  fill: "white"
});

const SvgSquareFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSquareFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/square-filled.98fdbb98.svg";
export { ForwardRef as ReactComponent };